export default __webpack_public_path__ + "static/media/icon_upload.37210303.svg";